/* eslint-disable filenames/match-regex */
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Shared JSON-LD script renderer.
 *
 * @param {object} props
 * @param {object} props.item Structured data payload.
 *
 * @return {object} Script element with serialized JSON-LD.
 */
export default function JsonLd({ item, inHead = false }) {
    const script = (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }}
        />
    );

    if (inHead) {
        return <Helmet>{script}</Helmet>;
    }

    return script;
}

JsonLd.propTypes = {
    item: PropTypes.object.isRequired,
    inHead: PropTypes.bool
};
